module.exports = __webpack_public_path__ + "static/subaru-0e73c636bcee6bc74c0bb96489237d1f.jpg";